import { SVGProps } from 'react';

const PlayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path d="M24 24H0V0H24V24Z" stroke="#E5E7EB" />
    <path
      d="M6 1.5V3H3.75C2.50781 3 1.5 4.00781 1.5 5.25V7.5H22.5V5.25C22.5 4.00781 21.4922 3 20.25 3H18V1.5C18 0.670312 17.3297 0 16.5 0C15.6703 0 15 0.670312 15 1.5V3H9V1.5C9 0.670312 8.32969 0 7.5 0C6.67031 0 6 0.670312 6 1.5ZM22.5 9H1.5V21.75C1.5 22.9922 2.50781 24 3.75 24H20.25C21.4922 24 22.5 22.9922 22.5 21.75V9ZM12 11.625C12.6234 11.625 13.125 12.1266 13.125 12.75V15.375H15.75C16.3734 15.375 16.875 15.8766 16.875 16.5C16.875 17.1234 16.3734 17.625 15.75 17.625H13.125V20.25C13.125 20.8734 12.6234 21.375 12 21.375C11.3766 21.375 10.875 20.8734 10.875 20.25V17.625H8.25C7.62656 17.625 7.125 17.1234 7.125 16.5C7.125 15.8766 7.62656 15.375 8.25 15.375H10.875V12.75C10.875 12.1266 11.3766 11.625 12 11.625Z"
      fill="currentColor"
    />
  </svg>
);

export default PlayIcon;
